import 'isomorphic-unfetch';

export const getSession = () =>
  fetch(`/_internal/session`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Set-Viewed-Experiments': '1',
    },
  }).then(res => res.json());

export const putSession = (key, value) =>
  fetch(`/_internal/session`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Set-Viewed-Experiments': '1',
    },
    body: JSON.stringify({
      [key]: value,
    }),
  });

export const putPrivacySettings = value =>
  fetch(`/_internal/privacy-settings`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(value),
  });

export const graphql = (query, variables, options = {}) =>
  fetch(`/_internal/graphql`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({
      query,
      variables,
      release: window !== undefined ? window.RELEASE : 'unknown',
    }),
    ...options,
  }).then(res => res.json());

export const postFeedback = message =>
  graphql(
    `
      mutation($data: FeedbackInputType!) {
        feedback(data: $data) {
          success
        }
      }
    `,
    { data: message }
  );

export const fetchShopReview = reviewId =>
  graphql(
    `
      query($reviewId: ID!) {
        shopReview(reviewId: $reviewId) {
          id
          rating
          reviewText
          purchaseDate
          answers {
            id
            answer
          }
        }
      }
    `,
    { reviewId }
  );
